const API_URL = process.env.REACT_APP_API_URL || '/api';

export interface HiredEquipmentRowAttachmentDto {
  filename: string;
  contentType: string;
  size: number;
  url: string;
  key: string;
}

export async function uploadHiredEquipmentRowAttachment(file: File): Promise<HiredEquipmentRowAttachmentDto> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch(`${API_URL}/hired-equipment/attachments`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    let message = 'Failed to upload attachment';
    try {
      const body = (await response.json()) as { error?: string; details?: string };
      message = body?.error || body?.details || message;
    } catch {
      // ignore
    }
    throw new Error(message);
  }
  return response.json() as Promise<HiredEquipmentRowAttachmentDto>;
}
